import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-skills',
  templateUrl: './skeleton-skills.component.html',
  styleUrls: ['./skeleton-skills.component.scss']
})
export class SkeletonSkillsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
